import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEmployee } from '@signal/asp-data-commons';
import { MasterSlot, ShopMaxPerDay, PerDaySlotsForCustomData} from '../../shared/models/slot-management.model';
import { FeatureKeys } from '../app.reducer';
import { selectActiveEmployees } from '../employee/employee.selectors';
import { SlotState } from './slot.reducer';
import * as fromAdapter from './slot.adapter';

export const selectSlotFeature = createFeatureSelector<SlotState>(FeatureKeys.SLOT);

export const selectMasterSlots = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.masterSlots.data
);

export const selectActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.activateIndicators.data
);

export const selectTechnicianActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.technicianactivateIndicators.data
);

export const selectShuttleActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.shuttleactivateIndicators.data
);

export const selectRentalActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.rentalactivateIndicators.data
);



export const selectRemoteActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.remoteactivateIndicators.data
);

export const selectShopMaxTotal = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.shopMaxTotal.data
);
export const selectMaxShopCapacityIsPrsent= createSelector(
    selectShopMaxTotal,
    (state: ShopMaxPerDay[]) => {
        let slotcapcitypresent:boolean=false;
        for(const item of state)
        {
            if(item.slotCapacity && item.slotCapacity!==0 ){
                slotcapcitypresent=true;
            }
        }
        return slotcapcitypresent;
    }
);
export const selectShopMaxSlots = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.shopMaxSlots?.data?.slotsPerDay
);

export const selectTeamMaxTotal = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.teamMaxTotal.data
);

export const selectTeamMaxSlotsForTeamId = createSelector(
    selectSlotFeature,
    (state: SlotState, props: {teamId: string}) => state.teamMaxSlots.data.find(x => x.teamId == props.teamId)?.slotsPerDay
);

export const selectTechnicianMaxTotal = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.technicianTotal.data
);

export const selectTechnicianAndSlotsByTeamId = createSelector(
    selectSlotFeature,
    selectActiveEmployees,
    (state: SlotState, employees: IEmployee[], props: { teamId: string}) =>
    ({
        slots: state.technicianSlots.data.find(x => x.teamId == props.teamId),
        employees
    })
);
export const selectTxmTeamMaxTotal = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.txmTeamMaxTotal.data
);

export const selectMaxAndMasterSlots = createSelector(
    selectShopMaxTotal,
    selectTeamMaxTotal,
    selectTxmTeamMaxTotal,
    selectMasterSlots,
    (
        shopMax: ShopMaxPerDay[],
        teamMax: PerDaySlotsForCustomData[],
        txmTeamMax: ShopMaxPerDay[],
        masterSlot: MasterSlot[],
        props: { view: string}
    ) => fromAdapter.getMaxAndMasterSlots(shopMax, teamMax, txmTeamMax, masterSlot, props)
);

export const selectTransportMaxSlots = createSelector(
    selectSlotFeature,
    (state: SlotState, props: { view: string}) => fromAdapter.getTransportMaxSlots(state, props)
);

export const selectTransportMaxTotal = createSelector(
    selectSlotFeature,
    (state: SlotState, props: { view: string}) => fromAdapter.getTransportMaxTotal(state, props)
);

export const selectTransportMaxAndMasterSlots = createSelector(
    selectSlotFeature,
    (state: SlotState, props: { view: string}
    ) => fromAdapter.getTransportMaxAndMasterSlots(state, props)
);

export const selectEmptySlots = createSelector(
    selectSlotFeature,
    (state: SlotState) => fromAdapter.enrichShopMaxSlots({slotsPerDay : []}).slotsPerDay
);

export const selectMasterSlotsLoading = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.masterSlots.loaded
);

export const selectTxmTeamMaxSlots = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.txmTeamMaxSlots?.data?.slotsPerDay
);

export const selectTxmActivateIndicators = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.txmActivateIndicators.data
);

export const selectShopSlotsUpdated = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.shopMaxSlots.isUpdated && state.shopMaxTotal.isUpdated
);
export const selecTeamSlotsUpdated = createSelector(
    selectSlotFeature,
    (state: SlotState) => state.teamMaxSlots.isUpdated && state.teamMaxTotal.isUpdated
);